import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "../../lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/testimonials").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section className="py-20 md:py-28 bg-[#013d2b]" data-testid="home-testimonials">
      <div className="max-w-6xl mx-auto px-5">
        <p className="text-[#c9a227] font-semibold tracking-[0.2em] text-xs uppercase">Student Stories</p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mt-2 max-w-2xl">What our students &amp; alumni say</h2>
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {items.slice(0, 6).map((t) => (
            <div key={t.id} className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm">
              <Quote className="text-[#c9a227]" size={26} />
              <div className="flex gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={14} className={n <= (t.rating || 5) ? "fill-[#c9a227] text-[#c9a227]" : "text-white/20"} />)}
              </div>
              <p className="text-white/85 text-sm mt-3 leading-relaxed">"{t.text}"</p>
              <div className="mt-4 pt-4 border-t border-white/10">
                <p className="text-white font-semibold text-sm">{t.name}</p>
                {t.programme && <p className="text-white/50 text-xs">{t.programme}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
